import * as React from "react";

interface IProps {
    text: string;
}

export function SubHeading(props: IProps) {
    const { text } = props;
    if (!text)
        return null;

    return (
        <div className="dash-subheading">{text}</div>
    );
}